import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { ConnectorSyncStatus } from "../components/Common/Sync/useConnectorSync";

const useGetTransportSyncStatus = (siteId: string, notificationId: string, options?: QueryOptions<ConnectorSyncStatus>) => {
  const business = useSelectedBusiness();
  return useUserQuery<ConnectorSyncStatus>({
    path: `/api/businesses/${business.id}/transports/sync/status?siteId=${siteId}&notificationId=${notificationId}`,
  }, options);
}

export default useGetTransportSyncStatus;
